// ============= Imports =============
import React from 'react';
import { Card } from '@tw/tw-component-library';
import {
  Container,
  Description,
  ErrorText,
  OptionsList,
  Pill,
  PillRow,
  Title,
} from './styles';
import type { VisualPromptSingleSelectStepProps } from './types';

// ============= Component =============
export const VisualPromptSingleSelectStep: React.FC<
  VisualPromptSingleSelectStepProps
> = ({ step, answers, onAnswer, error }) => {
  const current = String(answers[step.mapsTo] ?? '');

  const handleSelect = (label: string) => {
    onAnswer(step.mapsTo, label);
  };

  const usePills = step.type === 'singleSelectPills';

  return (
    <Container>
      <Title>{step.title}</Title>
      {step.description && <Description>{step.description}</Description>}
      {usePills ? (
        <PillRow>
          {step.options.map((opt) => (
            <Pill
              key={opt.id}
              type="button"
              $active={current === opt.label}
              onClick={() => handleSelect(opt.label)}
            >
              {opt.label}
            </Pill>
          ))}
        </PillRow>
      ) : (
        <OptionsList>
          {step.options.map((opt) => (
            <Card
              key={opt.id}
              hover
              active={current === opt.label}
              onClick={() => handleSelect(opt.label)}
            >
              <strong>{opt.label}</strong>
              {opt.description && <p>{opt.description}</p>}
            </Card>
          ))}
        </OptionsList>
      )}
      {error && <ErrorText>{error}</ErrorText>}
    </Container>
  );
};
